export default class SearchService {

    url = "https://viewfinderfuncydev1.azurewebsites.net/api/PhotoSearchFunc?code=BWpgAYyfTvZC8mwZpAucyvJNyo3degBflxcOPd9CIJE5ww7GrnqnHw==";
    search(){
        return fetch(this.url).then(function (response) {
            return response.json();
        })
        .then(function (data) {
            return data
        })
        .catch(function (err) {
        console.log(err);
        });
    }

    transformLocationToQueryString(location){
        const northEast = Object.getPrototypeOf(location).getNorthEast.call(location);
        const northWest = Object.getPrototypeOf(location).getNorthWest.call(location);
        const southWest = Object.getPrototypeOf(location).getSouthWest.call(location);
        const southEast = Object.getPrototypeOf(location).getSouthEast.call(location);
        return `${northEast.lng} ${northEast.lat}, ${northWest.lng} ${northWest.lat}, ${southWest.lng} ${southWest.lat}, ${southEast.lng} ${southEast.lat}, ${northEast.lng} ${northEast.lat}`;
    }

    searchWithBounds(data){
        const locationQuery = this.transformLocationToQueryString(data)
        return fetch(`${this.url}&PolygonPoints=${locationQuery}&numberOfPhotos=60`).then(function (response) {
            return response.json();
        })
        .then(function (data) {
            return data
        })
        .catch(function (err) {
        console.log(err);
        });
    }
}